<div class="alert-label pink-alert zk-w-full zk-flex zk-gap-3">
	<div class="zk-w-3 zk-flex info-icon">
		<span class="freud-icon freud-icon-info-circle freud-icon-xs"></span>
	</div>
	<div class="zk-w-11/12">
		<div class="zk-mb-2">
			<p
				id="pj-will-change-at"
				[innerHTML]="
					'MY_ACCOUNT.FINANCIAL.BANK_DATA.PROFILE_UPDATE_AT'
						| translate: { date: professionalWillBecomePjAt }
				"
			></p>
			<p
				[innerHTML]="
					'MY_ACCOUNT.FINANCIAL.BANK_DATA.DATA_BANK_UPDATE_AFTER'
						| translate
							: {
									month:
										'CALENDAR.MONTHS.' +
											PJMonthValidity.toUpperCase() +
											'.FULL_LOWER' | translate,
									date: professionalShouldChangeFinancialDataAt
							  }
				"
			></p>
		</div>
		<div>
			<p
				[innerHTML]="
					'MY_ACCOUNT.FINANCIAL.BANK_DATA.NFS_EMIT_ALERT'
						| translate
							: {
									dateClients: professionalWillBecomePjAt,
									dateZen: professionalShouldSendNFAfter
							  }
				"
			></p>
		</div>
	</div>
</div>
